module.exports = __webpack_public_path__ + "static/media/lensfest.png.51a95468.sb-e45a1285-S3OzVl";